import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import moment from 'moment';

class NhiemVuTTXM extends React.Component {
  render() {
    let ngayChuyen = this.props.ngayBatDauTTXM ? moment(this.props.ngayBatDauTTXM).format('DD/MM/YYYY') : '';
    let tgBaoCao = this.props.ngayHetHanTTXM ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : '';
    let yKien = this.props.yKienCuaDonViGiaoTTXM ? this.props.yKienCuaDonViGiaoTTXM : '';
    if (this.props.donInfo.laTTXMLai) {
      tgBaoCao = this.props.donInfo.ngayHetHanGiaiQuyetLanDau ? moment(this.props.donInfo.ngayHetHanGiaiQuyetLanDau).format('DD/MM/YYYY') : '';
      ngayChuyen = this.props.donInfo.ngayBatDauTTXMLanDau ? moment(this.props.donInfo.ngayBatDauTTXMLanDau).format('DD/MM/YYYY') : '';
      yKien = this.props.donInfo.noiDungYeuCauTTXMLanDau || '';
    }
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block">
        <h2 className="title-14 mb15">Nhiệm vụ thẩm tra xác minh{lb2}</h2>
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter mb15">
            <Text className="col-25" label="Ngày chuyển:" value={ngayChuyen}/>
            <Text className="col-25" label={'Đơn vị giao '+lb1+':'} value={this.props.donViGiaoThamTraXacMinh ? this.props.donViGiaoThamTraXacMinh.ten : ''}/>
            <Text className="col-25" red ={true} label="Thời gian báo cáo kết quả:" value={tgBaoCao}/>
          </div>
          <div className="col-100 no-gutter">
            <TextMessage className="col-100" label={"Ý kiến của đơn vị giao "+lb1+":"} value={yKien}/>
          </div>
        </div>
        {
          this.props.donInfo.laTTXMLai ?
            <div className="mt15 mb10">
              <div className="pt5 pb15">
                <span className="line-border"></span>
              </div>
              <h2 className="title-14 mb15">Nhiệm vụ thẩm tra xác minh{lb2} lại</h2>
              <div className="row pl10 pr10">
                <div className="col-100 no-gutter mb15">
                  <Text className="col-25" label="Ngày chuyển:" value={this.props.ngayBatDauTTXM ? moment(this.props.ngayBatDauTTXM).format('DD/MM/YYYY') : ''}/>
                  <Text className="col-25" label={"Đơn vị giao "+lb1+":"} value={this.props.donViGiaoThamTraXacMinh ? this.props.donViGiaoThamTraXacMinh.ten : ''}/>
                  <Text className="col-25" red ={true} label="Thời gian báo cáo kết quả:" value={this.props.ngayHetHanTTXM ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
                </div>
                <div className="col-100 no-gutter">
                  <TextMessage className="col-100" label={"Ý kiến của đơn vị giao "+lb1+":"} value={this.props.yKienCuaDonViGiaoTTXM ? this.props.yKienCuaDonViGiaoTTXM : ''}/>
                </div>
              </div>
            </div>
          :''
        }
      </section>
    );
  }
}

NhiemVuTTXM.defaultProps = {
  donViGiaoThamTraXacMinh: {
    ten: ''
  },
  ngayHetHanTTXM: '',
  yKienCuaDonViGiaoTTXM: '',
  ngayBatDauTTXM: '',
  donInfo: {}
}

export default NhiemVuTTXM;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/NhiemVuTTXM.jsx